module.exports = __webpack_public_path__ + "img/not-items.37a97eae.png";